const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";

export async function fetchBookings() {
  const token = localStorage.getItem("bigBearJWTToken");
  const res = await fetch(`${API_URL}/bookings`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.error || "Failed to fetch bookings");
  }

  return res.json();
}
